/**
 * @mixin
 */
export default {
    // https://frfraadevengagementfinder0001.azurewebsites.net/
    // http://localhost:5040/
    data: () => ({
        getFilter: "/v1/Crendentials?$count=true&%24filter=",

        CridentialsPropositions: "/v1/CrendentialsPropositionsAttributions?%24filter=credentialGuid%20eq%20",
        CridentialsMarkets: "/v1/CrendentialsMaketsAttributions?%24filter=credentialGuid%20eq%20",
        CridentialsCountries: "/v1/CrendentialsCountriesAttributions?%24filter=credentialGuid%20eq%20",
        CridentialsTechnologies: "/v1/CrendentialsTechnologiesAttributions?%24filter=credentialGuid%20eq%20",

        getPropositionsApi: "/v1/Propositions",
        getCountriesApi: "/v1/Countries",
        getMarketsApi: "/v1/Makets",
        getTechnologiesApi: "/v1/Technologies",

        draft: "StepGu%2FTitle%20eq%20'draft'",
        published: "StepGu%2FTitle%20eq%20'published'",
        RejectedByCom: "StepGu%2FTitle%20eq%20'RejectedByCom'%20or%20StepGu%2FTitle%20eq%20'rejectedByManager'",
        rejectedByManager: "StepGu%2FTitle%20eq%20'rejectedByManager'",
        validatedByCom: "StepGu%2FTitle%20eq%20'validatedByCom'",
        getCommentById : "/v1/StepsHistory?%24filter=credentialGuid%20eq%20"





    }),
    computed: {},
    methods: {},
    mouted() {

    }
};